import { createSlice } from '@reduxjs/toolkit';
import extraReducers from 'src/redux/work-order/extra-reducers';
import reducers from 'src/redux/work-order/reducers';
import { workOrderInitialState } from './types';

const workOrderSlice = createSlice({
  name: 'workOrder',
  initialState: workOrderInitialState,
  reducers,
  extraReducers: (builder) => extraReducers(builder),
});

export const {
  updateWorkOrdersByGroupOptions,
  clearWorkOrderData,
  clearOwnerQuoteRevalidation,
  setGroupedDataMetaLoading,
  shouldSidePanel,
  updateSidePanelDetails,
  updateWorkOrderDetails,
  updateWorkOrderNte,
  updateWorkOrderDetailsAccessMethod,
  updateWorkOrderDetailsPropertyAddress,
  updateWorkOrderDetailsNteAmount,
  updateResidentInfo,
  setCurrentScheduleStep,
  toggleToRefetchWorkOrderDetails,
  updateTripData,
  updateMultipleTripData,
  updateQuoteStep,
  removeWoIdFromList,
  addToWoListOrReorderTheList,
  updateWorkOrderAssigneeDetails,
  resetSidePanelToActivityLog,
  updateTagSource,
  updateTagDetails,
  clearTagListingData,
  deleteTagFromSource,
  updateWOAppointmentValues,
  updateResidentAvailabilityRequestedAt,
  resolveResidentAvailabilityRequest,
  reconcileResidentAvailabilityRequest,
  toggleVendorEditMode,
  updateTimerState,
  setFromServiceRequest,
  switchWorkOrder,
  updateAllTagList,
  removeIssueFromWorkOrder,
  addIssuesToWorkOrder,
  updateIssueInWoSlice,
  removeIssueFromWo,
  deleteWorkOrder,
  updateWoSliceKey,
  updateQuoteSource,
  addQuoteToWo,
  updateQuoteState,
  shouldRefetchQuote,
  updateCloseTripData,
  updateResidentAvailabilityDatesWo,
  bumpResidentAvailabilityRevision,
  updateInvoiceStep,
  updateInvoiceList,
} = workOrderSlice.actions;

export default workOrderSlice.reducer;
